export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://localhost:7072';
export const BASE_URL = import.meta.env.VITE_BASE_URL || 'https://localhost:5173/';
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const NETCASH_SERVICE_KEY = import.meta.env.VITE_NETCASH_SERVICE_KEY;
export const NETCASH_VENDOR_KEY = import.meta.env.VITE_NETCASH_VENDOR_KEY;
export const NETCASH_DEBIT_ORDER_SERVICE_KEY = import.meta.env.VITE_NETCASH_DEBIT_ORDER_SERVICE_KEY;
